export const appInfo = {
    title: 'TeamPilot',
  };
  